export {
  abbr,
  shortKey,
  shortHash,
  formatAmountHuman,
  formatSol,
  formatMoney,
} from '@/components/_shared/format'

import { formatSol } from '@/components/_shared/format'

export function formatLamports(v) {
  const n = Number(v || 0)
  if (!Number.isFinite(n) || n <= 0) return '0'
  return formatSol(n)
}
